import FilterModel from '../searchFilter/index.model.js';
const model = {
    name: 'Include',
    properties: {
        filter: { type: 'model', model: FilterModel, required: true },
        slots: { type: 'array', required: true }, // TODO: Array of integers <int64>
    },
};
export default model;
